<wm-contractor-profile
  *ngIf="contractorId && clientId"
  [contractorId]="contractorId"
  [clientId]="clientId"
></wm-contractor-profile>
